module.exports = __webpack_public_path__ + "img/0254867c30c8a54b7d8e828b6e059c78.png";